"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _vue = _interopRequireDefault(require("vue"));
var bus = new _vue.default({
  methods: {
    on: function on(event, callback) {
      this.$on(event, callback);
      return this;
    },
    once: function once(event, callback) {
      this.$once(event, callback);
      return this;
    },
    off: function off(event, callback) {
      this.$off(event, callback);
      return this;
    },
    emit: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      this.$emit.apply(this, [event].concat(args));
      return this;
    }
  }
});
var _default = exports.default = {
  install: function install(vue) {
    Object.defineProperty(vue.prototype, '$bus', {
      get: function get() {
        return bus;
      }
    });
  }
};